(function(){
  var root = document.getElementById('vy');
  if (!root) return;
  function $(s){ return root.querySelector(s); }
  function $$(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); }
  function fmt(c){ return '€' + (c/100).toFixed(2).replace('.', ','); }
  function replay(el, cls){ el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
  var rv = $$('.rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: 0.12 });
    rv.forEach(function(el){ io.observe(el); });
  } else { rv.forEach(function(el){ el.classList.add('in'); }); }
  var main = $('#vy-main');
  $$('.thumb').forEach(function(b){
    b.addEventListener('click', function(){
      main.src = b.dataset.src; main.alt = b.dataset.alt; replay(main, 'pop');
      $$('.thumb').forEach(function(t){ t.setAttribute('aria-current', t === b ? 'true' : 'false'); });
    });
  });
  var variant = root.dataset.v1;
  function setBundle(btn){
    $$('.bundle').forEach(function(b){ b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
    variant = btn.dataset.variant;
    var p = +btn.dataset.price, c = +btn.dataset.compare;
    $$('[data-bp]').forEach(function(e){ e.textContent = fmt(p); });
    $$('[data-bc]').forEach(function(e){ e.textContent = fmt(c); });
    $$('[data-bs]').forEach(function(e){ e.textContent = fmt(c - p); });
  }
  $$('.bundle').forEach(function(b){ b.addEventListener('click', function(){ setBundle(b); }); });
  $$('.mode-btn').forEach(function(b){
    b.addEventListener('click', function(){
      $$('.mode-btn').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var im = $('#vy-mode-img'); im.src = b.dataset.img; im.alt = b.dataset.alt; replay(im, 'pop');
      $('#vy-mode-inset').src = b.dataset.inset;
      $('#vy-mode-cap').textContent = b.dataset.cap;
      $('#vy-mode-text').textContent = b.dataset.text;
    });
  });
  var C = 2 * Math.PI * 140, ring = $('#vy-ring'), num = $('#vy-tnum');
  function setTemp(b){
    var col = b.dataset.color;
    $$('.temp').forEach(function(x){ var on = x === b; x.setAttribute('aria-pressed', on ? 'true' : 'false'); x.style.borderColor = on ? x.dataset.color : ''; });
    ring.setAttribute('stroke', col);
    ring.setAttribute('stroke-dasharray', (C * +b.dataset.frac).toFixed(1) + ' ' + C.toFixed(1));
    num.textContent = b.dataset.t; num.style.color = col; num.style.textShadow = '0 0 18px ' + col;
  }
  $$('.temp').forEach(function(b){ b.addEventListener('click', function(){ setTemp(b); }); });
  var t0 = $('.temp[aria-pressed="true"]'); if (t0) setTemp(t0);
  var wrap = $('#vy-drawer'), body = $('#vy-items'), total = $('#vy-total'), err = $('#vy-err');
  function el(tag, cls, txt){ var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function change(key, q){
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }).then(refresh);
  }
  function refresh(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){
      $$('[data-count]').forEach(function(e){ e.textContent = c.item_count; });
      total.textContent = fmt(c.total_price);
      body.innerHTML = '';
      if (!c.items.length) { body.appendChild(el('p', 'lead', 'Il tuo carrello è vuoto per ora.')); return; }
      c.items.forEach(function(it){
        var row = el('div', 'line');
        var img = el('img'); img.alt = ''; if (it.image) img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200'; row.appendChild(img);
        var info = el('div', 'line-info');
        info.appendChild(el('b', '', it.product_title));
        if (it.variant_title) info.appendChild(el('small', '', it.variant_title));
        var q = el('div', 'qty');
        var minus = el('button', '', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Diminuisci');
        minus.onclick = function(){ change(it.key, it.quantity - 1); };
        var plus = el('button', '', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Aumenta');
        plus.onclick = function(){ change(it.key, it.quantity + 1); };
        q.appendChild(minus); q.appendChild(el('span', '', String(it.quantity))); q.appendChild(plus);
        q.appendChild(el('b', '', '  ' + fmt(it.final_line_price)));
        info.appendChild(q);
        var rm = el('button', 'rm', 'Rimuovi'); rm.type = 'button'; rm.onclick = function(){ change(it.key, 0); };
        info.appendChild(rm);
        row.appendChild(info);
        body.appendChild(row);
      });
    });
  }
  function openCart(){ wrap.hidden = false; document.documentElement.style.overflow = 'hidden'; var x = wrap.querySelector('.xbtn'); if (x) x.focus(); }
  function closeCart(){ wrap.hidden = true; document.documentElement.style.overflow = ''; }
  $$('[data-open-cart]').forEach(function(b){ b.addEventListener('click', function(){ refresh(); openCart(); }); });
  $$('[data-close-cart]').forEach(function(b){ b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !wrap.hidden) closeCart(); });
  $$('[data-add]').forEach(function(b){
    b.addEventListener('click', function(){
      var btns = $$('[data-add]'); btns.forEach(function(x){ x.disabled = true; }); if (err) err.textContent = '';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +variant, quantity: 1 }] }) })
        .then(function(r){ if (!r.ok) throw new Error('add'); return refresh(); })
        .then(openCart)
        .catch(function(){ if (err) err.textContent = 'Si è verificato un errore. Riprova.'; })
        .then(function(){ btns.forEach(function(x){ x.disabled = false; }); });
    });
  });
  refresh();
  var sticky = $('#vy-sticky'), hero = $('#top'), buy = $('#prodotto');
  function onScroll(){
    var y = window.scrollY, h = hero ? hero.offsetHeight : 600;
    var r = buy ? buy.getBoundingClientRect() : null;
    var inBuy = r && r.top < window.innerHeight * 0.6 && r.bottom > window.innerHeight * 0.4;
    sticky.classList.toggle('show', y > h * 0.8 && !inBuy);
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
})();